<template>
  <div class="header">
    <div class="header-nav">
      <div class="logo flex-row-start">
        <img src="../../assets/images/login/logo_js.png" class="logo-img" alt="" />
      </div>
      <div class="role">
        <div class="role-name" @click="onGoIndex">
          {{ roleName }}
        </div>
        <div class="nav-list flex-row-end">
          <div class="header-nav-list ">
            <ul>
              <li class="header-nav-list-li header-nva-item">
                <el-dropdown placement="top-start" @command="onStageSubject">
                  <span class="dropdown-link">
                    当前：{{
                      stageSubjectIng.stage.name + stageSubjectIng.subject.name
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" @click="onStageSubject">
                    <div
                      class="dropdown-box"
                      v-for="(item, index) in stageSubjectList"
                      :key="index"
                    >
                      <div class="title flex-row-start">
                        <div class="line"></div>
                        <div>{{ item.name }}</div>
                      </div>
                      <div class="dropdown-content">
                        <el-dropdown-item
                          class="dropdown-content-item"
                          :class="{
                            active: v.id === stageSubjectIng.subject.id && stageSubjectIng.stage.id ==item.id,
                          }"
                          v-for="(v, i) in item.children"
                          :key="i"
                          :command="{ stage: item, subject: v }"
                          >{{ v.name }}</el-dropdown-item
                        >
                      </div>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
              <li
                class="header-nav-list-li header-nva-item"
                :class="{ active: '/teacher/assignment' == pathString }"
                @click="onSelectNav('/teacher/assignment')"
              >
                班级作业
              </li>
              <li
                class="header-nav-list-li header-nva-item"
                :class="{ active: '/work/chapter' == pathString }"
                @click="onSelectNav('/work/chapter')"
              >
                章节选题
              </li>
              <li
                class="header-nav-list-li header-nva-item"
                :class="{ active: '/work/knowledge' == pathString }"
                @click="onSelectNav('/work/knowledge')"
              >
                知识点选题
              </li>
              <li
                class="header-nav-list-li header-nva-item"
                :class="{ active: '/work/smart/knowledge' == pathString }"
                @click="onSelectNav('/work/smart/knowledge')"
              >
                智能选题
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      roleName: "作业",
      stageSubjectList: [],
      stageSubjectIng: {
        stage: { name: "" },
        subject: { name: "", code: "" },
      },
    };
  },
  props: {
    pathString: String,
  },
  watch: {
    pathString() {},
  },
  computed: {
    ...mapState(["user", "stageSubject"]),
  },
  created() {
    this.getStageSubjectData();
    // this.stageSubjectIng = this.stageSubject;
  },

  methods: {
    ...mapActions(["STAGE_SUBJECT_IN"]),
    init() {},
    getStageSubjectData() {
      this.getRequest("/wenjiaoopne/getQuestionStageSubject", )
        .then((result) => {
          this.stageSubjectList = result.data;
          if (JSON.stringify(this.stageSubject) === "{}") {
            let initStageSubject = {
              stage: this.stageSubjectList[0],
              subject: this.stageSubjectList[0].children[0],
            };
            this.STAGE_SUBJECT_IN(initStageSubject);
            this.stageSubjectIng = initStageSubject;
            location.reload();
          } else {
            this.stageSubjectIng = this.stageSubject;
          }
        })
        .catch(() => {});
    },
    onStageSubject(item) {
      this.STAGE_SUBJECT_IN(item);
      this.stageSubjectIng = item;
      location.reload();
    },
    onSelectNav(url) {
      if (this.pathString === url) {
        return false;
      }
      this.$router.push(url);
    },
    onGoIndex() {
      // this.$router.push("/");
    },
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  min-width: 1195px;
  background-color: #f3f1f1;
}
.dropdown {
  height: 55px;
}
.el-dropdown-link {
  color: #333;
  font-size: 16px;
  line-height: 97px;
}

.dropdown-link {
  display: inline-block;
  height: 100px;
  font-size: 16px;
}
.header {
  background-color: #fff;
}
.header-nav {
  position: relative;
  width: 1195px;
  margin: 0 auto;
  height: 100px;
  line-height: 100px;
  font-size: 14px;
}
.dropdown-item {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.header .logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 227px;
  height: 100px;
}
.logo-img {
  height: 60px;
}
.header .logo-image {
  display: inline-block;
  width: 100%;
  height: 58px;
  background: url(https://www.canpoint.net//Template/style1/style_img/v4_img/hd_icon.png)
    no-repeat 0 -250px;
}
.header .role {
  position: relative;
  margin-left: 250px;
  height: 100px;
  background-color: #41b9f1;
  border-radius: 50px 0 0 50px;
}
.header .role .role-name {
  position: absolute;
  top: 0;
  left: 0;
  width: 110px;
  height: 100px;
  font-size: 24px;
  text-align: center;
  color: #fff;
}
.header .role .nav-list {
  margin-left: 110px;
  width: 836px;
  height: 100px;
  background-color: #fff;
  border-radius: 50px 0 0 50px;
}
.header .nav_site {
  float: right;
}
.header .nav_site li {
  width: 90px;
  height: 97px;
  line-height: 97px;
  float: left;
  text-align: center;
  border-bottom: 2px solid #fff;
}
.header .nav_site li.active {
  border-bottom: 2px solid #02a4ee;
}
/* .header .nav_site li:hover {
  border-bottom: 2px solid #02a4ee;
} */
.header .nav_site li.active a,
.header .nav_site li:hover a,
.header .nav_site li:hover {
  color: #02a4ee;
}
.header .nav_site li > a {
  color: #333;
  font-size: 16px;
  line-height: 97px;
}
.header-nav-list {
  /* width: 405px; */
  position: relative;
  height: 100px;
}
.header-nav-list ul {
  margin: 0 auto;
}
.header-nav-list-li {
  width: 170px;
  float: left;
}
.header-nav-list .header-nva-item {
  position: relative;
  width: 135px;
  text-align: center;
  padding: 0;
  color: #333;
  font-size: 16px;
  cursor: pointer;
}
.header-nav-list .active,
.header-nav-list .header-nva-item:hover {
  color: #02a4ee;
}
.header-nav-list li.active {
  border-bottom: 2px solid #02a4ee;
}
.dropdown-box {
  padding: 0 20px;
  width: 360px;
  /* height: 100px; */
}
.dropdown-box .title {
  width: 100%;
  font-size: 16px;
  font-weight: 700;
  margin: 15px 0;
}
.dropdown-box .title .line {
  height: 18px;
  width: 4px;
  margin-right: 8px;
  background-color: #12acf4;
}
.dropdown-content-item {
  display: inline-block;
  margin: 2px 2px;
  font-size: 14px;
  cursor: pointer;
}
.dropdown-content-item:hover,
.dropdown-box .active {
  border-radius: 30px;
  background-color: #41b9f1;
  color: #fff;
}
</style>
